import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';
import { ReportingService } from 'src/app/_service/reporting.service';
import { URLS } from 'src/app/constants/URLS';

@Component({
  selector: 'app-report-modal',
  templateUrl: './report-modal.component.html',
  styleUrls: ['./report-modal.component.css']
})
export class ReportModalComponent implements OnInit {

  reportTypes:any[] = [];
  isLoading:boolean = false;
  selectedReportType:string | null = null;
  vidLibId:string = '';
  termsAccepted:boolean = false;

  constructor(
    private reportService: ReportingService,
    private dialogRef: MatDialogRef<ReportModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private toastrService: CustomControlsService
  ) { 
    this.vidLibId = data.vidLibId;
    console.log(this.vidLibId);
  }

  ngOnInit(): void {
    this.getReportTypes();
  }

  getReportTypes(){
    this.isLoading = true;
    this.reportService.getReportTypes().subscribe((result)=>{
      console.log(result);
      this.reportTypes = result;
      this.isLoading = false;
    },(error)=>{
      console.log(error);
      this.isLoading = false;
    })
  }
  
  toggleCheckbox(event: Event){
    const input = event.target as HTMLInputElement;
    this.termsAccepted = input.checked;
  }

  submitReport(){
    if(this.termsAccepted && this.selectedReportType){
      console.log(this.termsAccepted, this.selectedReportType);
      const requestBody = {
        "videoId": this.vidLibId,
        "originalVideoLink": `${URLS.BASE_URL}/static/toqqer-ui/#/tqr/video?vidLibId=${this.vidLibId}`,
        "reportType": this.selectedReportType,
        "isAgree": this.termsAccepted
      }
      this.isLoading = true;
      this.reportService.reportAbuse(requestBody).subscribe((result)=>{
        console.log(result);
        if(result.status){
          this.showSuccess(result.message);
        }
        this.dialogRef.close(true);
        this.isLoading = false;
      },(error)=>{
        this.isLoading = false;
      })
    }
  }

  close(){
    this.dialogRef.close();
  }

  showSuccess(message:any) {
    this.toastrService.showNotification(
      'success',
      '',
      message,
      3000
    );
  }
}
